import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { ReactComponent as Spinner } from '../../../images/icons/spinner.svg'
import { TOPID } from '../../../utils/runtimeConstants'

const RefreshButton = ({
                          queryStatus,
                          context,
                          spaceRight,
                          spaceLeft,
                        }) => {
  const [busy, setBusy] = useState(false)
  const g = context.global
  const userDataState = g.children[TOPID]

  useEffect(() => {
    setBusy(!!userDataState._updating)
  }, [!userDataState._updating])

  const doRefresh = async (linkExpr, keyValue, instanceId, linkType) => {
    try {
      setBusy(true)
      userDataState._updating = {} // cache for data object promises (during update)
      await userDataState.refreshCachedObject(linkExpr, keyValue, instanceId, linkType)
    } catch (e) {
      console.log(e)
    } finally {
      delete userDataState._updating // at this point the update is finished so we discard the cache
      setBusy(false)
    }
  }
  const buttonClasses = classNames('btn btn-outline-secondary dart-btn-outline',
    { 'mr-3': spaceRight, 'ml-3': spaceLeft })

  return (
    <button className={buttonClasses}
            style={{ backgroundColor: '#FFFFFF' }}
            disabled={busy}
            onClick={(e) => {
              doRefresh(
                queryStatus.linkExpr,
                queryStatus.linkValue,
                queryStatus.linkInstanceId,
                queryStatus.linkType,
              )
            }}>
      {busy
        ? <Spinner className={'rot'} style={{ width: 25, top: -4, position: 'relative' }}/>
        : `Refresh from ${queryStatus.queryDef.label}`
      }
    </button>
  )
}

export default RefreshButton
